import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import { H4, H6, Body2, Subtitle2 } from 'components/Typography';
import styles from './styles';
import { isNotNullOrEmpty, isEmptyObject } from 'utilities/is';
import m from 'messages';

class MissingCompetenciesView extends React.Component {

    extractDivision(c) {
        if (c.divisionSpecific) return `${c.name} ${isNotNullOrEmpty(c.divisionName) ? `(${c.divisionName})` : ''}`; 
        if (c.companySpecific) return `${c.name} ${isNotNullOrEmpty(c.companyName) ? `(${c.companyName})` : ''}`; 
        return c.name;
    }

    extractProject(c) {
        if (c.divisionSpecific) return `${c.name} ${isNotNullOrEmpty(c.divisionName) ? `(${c.divisionName})` : ''}`;
        if (c.projectSpecific) return `${c.name} ${isNotNullOrEmpty(c.projectName) ? `(${c.projectName})` : ''}`;
        if (c.companySpecific) return `${c.name} ${isNotNullOrEmpty(c.companyName) ? `(${c.companyName})` : ''}`;
        return c.name;
    }

    extractSite(c) {
        if (c.siteSpecific) return `${c.name} ${isNotNullOrEmpty(c.siteName) ? `(${c.siteName})` : ''}`;
        if (c.companySpecific) return `${c.name} ${isNotNullOrEmpty(c.companyName) ? `(${c.companyName})` : ''}`;
        if (c.divisionSpecific) return `${c.name} ${isNotNullOrEmpty(c.divisionName) ? `(${c.divisionName})` : ''}`;
        return c.name;
    }

    extractZone(c) {
        if (c.zoneSpecific) return `${c.name} ${isNotNullOrEmpty(c.zoneName) ? `(${c.zoneName})` : ''}`;
        if (c.companySpecific) return `${c.name} ${isNotNullOrEmpty(c.companyName) ? `(${c.companyName})` : ''}`;
        return c.name;
    }

    missingCompetences(groups, nameExtract) {

        const requirementPrefix = (nameExtract) => {
            return (c) => {
                let title = title => `${title}`;
                if (c.competenceID)
                    title = m.competencies.requirementPrefix.competency;
                else if (c.jobRoleID)
                    title = m.competencies.requirementPrefix.jobRole;
                return title(nameExtract(c));
            }
        }
        nameExtract = requirementPrefix(nameExtract);

        let missingValues = [];

        Object.keys(groups).forEach((key, index) => {
            let group = groups[key];

            let allGroup = [];
            let orGroup = [];
            for (const item of group) {
              
                if (!isNotNullOrEmpty(item.orGroup)) {

                    if (allGroup.length === 0) {
                        allGroup.push({
                            label: m.cards.missingCompetenciesAll,
                            missingCompetenceNames: [nameExtract(item)]
                        });
                    } else {
                        allGroup[0].missingCompetenceNames.push(nameExtract(item));
                    }
                } else {
                    if (orGroup.length === 0) {
                        orGroup.push({
                            label: m.cards.missingCompetenciesAtLeast,
                            missingCompetenceNames: [nameExtract(item)]
                        });
                    } else {
                        orGroup[0].missingCompetenceNames.push(nameExtract(item));
                    }
                }
            }
            missingValues = missingValues.concat(allGroup).concat(orGroup);

        });
        return missingValues;
    }

    renderGroup(group, extractor, title) {
        const classes = this.props.classes;
        let missing = this.missingCompetences(group, extractor);
        return (
            <React.Fragment>
                {missing.length > 0 &&
                    <div className={this.props.classes.contentContainer}>
                        <H4 paragraph className={classes.warning}>{title}</H4>
                        <H6>
                            {m.cards.missingCompetenciesHeader}
                        </H6>
                        {missing.map((g, index) =>
                            <div key={index}>
                                <Subtitle2 className={classes.row}>{g.label}</Subtitle2>
                                {g.missingCompetenceNames.map((mc, index) =>
                                    <div className={classes.row} key={index}>
                                        <Body2 className={classes.row}>{mc}</Body2>
                                        <Divider />
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                }
            </React.Fragment>
        );
    }

    render() {
        const { card, config, classes, location } = this.props;

        try {
            if (!location || isEmptyObject(location) || !Boolean(location.division)) { return (<div></div>); }

            return (
                <div className={classes.root}>
                    {this.renderGroup(card.missingDivisionRequirements, this.extractDivision, `${m.cards.invalidCompetenciesFor} ${config.divisionLevelName.toLowerCase()} ${location.division.divisionName}`)}
                    {this.renderGroup(card.missingProjectRequirements, this.extractProject, `${m.cards.invalidCompetenciesFor} ${config.projectLevelName.toLowerCase()} ${location.project.projectName}`)}
                    {this.renderGroup(card.missingSiteRequirements, this.extractSite, `${m.cards.invalidCompetenciesFor} ${config.siteLevelName.toLowerCase()} ${location.site.siteName}`)}
                    {location.zone && this.renderGroup(card.missingZoneRequirements, this.extractZone, `${m.cards.invalidCompetenciesFor} ${config.zoneLevelName.toLowerCase()} ${location.zone.zoneName}`)}
                </div>
            );
        } catch (e) {
            return (<div></div>);
        }
    }
}

MissingCompetenciesView.propTypes = {
    card: PropTypes.object,
    location: PropTypes.object,
    config: PropTypes.object
};

export default withStyles(styles)(MissingCompetenciesView);